module.exports = __webpack_public_path__ + "img/a-s.caa31db8.png";